import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
/**
 * Validator for number range between @param min and @param max
 * @param min
 * @param max
 * @returns
 */
export function createRangeValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const rangeValid = value >= min && value <= max;

    return !rangeValid ? { range: { min, max, actualValue: value } } : null;
  };
}
